const RELOAD_KEY = 'last_reload_ts';
const RELOAD_COOLDOWN_MS = 5000;

/**
 * Safe reload utility that prevents infinite reload loops.
 * Uses sessionStorage to track the last reload timestamp.
 * If a reload occurred within the cooldown period, it does nothing.
 */
export function safeReload(): boolean {
  try {
    const last = sessionStorage.getItem(RELOAD_KEY);
    if (last && Date.now() - Number(last) < RELOAD_COOLDOWN_MS) {
      return false; // Too soon, skip reload
    }
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
    return true;
  } catch {
    // sessionStorage unavailable — reload anyway but only once
    window.location.reload();
    return true;
  }
}
